<template>
    <div class="bottombar">
        <img @click="openHome"  src="./img/logo_dark.svg" alt="">
        <p class="cr">{{$t('footer.cpr', {fullYear: new Date().getFullYear()})}}</p>
        <p>
            <router-link :to="{name: 'aboutH5'}"><a>{{$t('footer.about')}}</a></router-link> |
            <!-- <a href="//www.komoejoy.com/contract/">聯繫我們</a> | -->
            <router-link :to="{name: 'termsH5'}">
            <a>{{$t('footer.rule')}}</a>
            </router-link>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'footer-h5',
        methods:{
                openHome() {
      if (this.$route.name == "homeH5") return;
      this.$router.push({ path: "/h5" });
    },
        }
    }
</script>

<style lang="scss">
    .bottombar{
        height: 1.8rem;
        background-color: #F2F2F2;
        text-align: center;
        padding: .2rem 0;
        box-sizing: border-box;
        img{
            width: 1.64rem;
            display: block;
            margin: 0 auto;
            height: .4rem;
        }
        p{
            font-size: .1rem;
            color: #999999;
            margin: 0;
            a{
                color: inherit;
                margin: 0 .15rem;
                text-decoration: none;
            }
            &.cr{
                margin-top: .1rem;
                margin-bottom: .2rem;
            }
        }
    }
</style>


